// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__X2eiw","active":"Footer_active__kvzt5","MadeIn":"Footer_MadeIn__o8vPA","Link":"Footer_Link__KK18f"};